<template>
  <layout>
    <rdkm-title>
      {{ query.patientId ? $t('Поиск фенотипа') : $t('Доноры') }}
      <span class="d-flex float-right">        
        <user-accessible routerName="ImportDonors">          
          <import-modal></import-modal>          
        </user-accessible>

        <user-accessible routerName="ExportDonors">
          <export-modal :organizationId="query.lrOrganizationId"></export-modal>
        </user-accessible>

        <user-accessible routerName="ExportWmdaDonors">
          <export-wmda-modal></export-wmda-modal>
        </user-accessible>

        <user-accessible routerName="ExportFmbaDonors">
          <export-fmba-modal></export-fmba-modal>
        </user-accessible>
        

        <user-accessible routerName="ImportDonors">
          <router-link tag="span" to="/donors/add">
            <b-button class="float-right" right size="sm" variant="primary">
              <font-awesome-icon icon="plus" />{{ $t('Добавить') }}
            </b-button>
          </router-link>
        </user-accessible>
      </span>
    </rdkm-title>
    <div class="tile donors-data" :class="showDeleted ? 'deleted-donors-data' : 'visible-donors-data'">
      <filter-form
        :patient="patient"
        :lrOrganizationId="filterQuery.lrOrganizationId"
        :externalId="filterQuery.externalId"
        :donorStatus="filterQuery.donorStatus"
        :state="filterQuery.state"
        :operatorId="filterQuery.operatorId"
        :showDeleted="filterQuery.showDeleted"
        :patientId="filterQuery.patientId"
        :ageFrom="filterQuery.ageFrom"
        :ageTo="filterQuery.ageTo"
        :coincidence="filterQuery.coincidence"
        :gender="filterQuery.gender"
        v-on:changeDeletedFilter="changeDeletedFilter($event)"
        v-on:search="$refs.grid.filter($event, true)"
      >
      </filter-form>
      <br v-if="filterQuery.patientId" />
      <rdkm-grid
        ref="grid"
        :state="filterQuery"
        :emptyDataLabel="$t('Отсутствуют подходящие фенотипы')"
        :export="!!filterQuery.patientId"
        :isCheckable="patient && patient.status == 2"
        :export-url="exportUrl"
      >
        <grid-column
          name="idd"
          :title="$t('IDD')"
          width="100"
          cell="edit-cell"
        ></grid-column>
        <grid-column
          key="lrCode"
          :title="$t('Код РР')"
          :format="(v, row) =>  { return row.destLrCode || v; }"
          width="85"
          name="lrCode"
        ></grid-column>
        <grid-column
          v-if="filterQuery.patientId"
          name="coincidence"
          :title="$t('Совместимость')"
          width="120"
        ></grid-column>
        <grid-column name="fullness" :title="$t('Полнота')" width="110"></grid-column>
        <grid-column
          :name="filterQuery.patientId ? 'hlaA1' : 'a1'"
          :className="(row) => (query.patientId && row.isColored ? 'red' : '')"
          title="A*"
          width="91"
        ></grid-column>
        <grid-column
          :name="filterQuery.patientId ? 'hlaA2' : 'a2'"
          :className="(row) => (query.patientId && row.isColored ? 'red' : '')"
          title="  "
          width="91"
        ></grid-column>
        <grid-column
          :name="filterQuery.patientId ? 'hlaB1' : 'b1'"
          :className="(row) => (query.patientId && row.isColored ? 'red' : '')"
          title="B*"
          width="91"
        ></grid-column>
        <grid-column
          :name="filterQuery.patientId ? 'hlaB2' : 'b2'"
          :className="(row) => (query.patientId && row.isColored ? 'red' : '')"
          title="  "
          width="91"
        ></grid-column>
        <grid-column
          :name="filterQuery.patientId ? 'hlaC1' : 'c1'"
          :className="(row) => (query.patientId && row.isColored ? 'red' : '')"
          title="C*"
          width="91"
        ></grid-column>
        <grid-column
          :name="filterQuery.patientId ? 'hlaC2' : 'c2'"
          :className="(row) => (query.patientId && row.isColored ? 'red' : '')"
          title="  "
          width="91"
        ></grid-column>
        <grid-column
          :name="filterQuery.patientId ? 'hlaDrb11' : 'drb11'"
          :className="(row) => (query.patientId && row.isColored ? 'red' : '')"
          title="DRB1*"
          width="96"
        ></grid-column>
        <grid-column
          :name="filterQuery.patientId ? 'hlaDrb12' : 'drb12'"
          :className="(row) => (query.patientId && row.isColored ? 'red' : '')"
          title="  "
          width="91"
        ></grid-column>
        <grid-column
          :name="filterQuery.patientId ? 'hlaDqb11' : 'dqb11'"
          :className="(row) => (query.patientId && row.isColored ? 'red' : '')"
          title="DQB1*"
          width="91"
        ></grid-column>
        <grid-column
          :name="filterQuery.patientId ? 'hlaDqb12' : 'dqb12'"
          :className="(row) => (query.patientId && row.isColored ? 'red' : '')"
          title="  "
          width="91"
        ></grid-column>
        <grid-column
          :name="filterQuery.patientId ? 'hlaDpb11' : 'dpb11'"
          :className="(row) => (query.patientId && row.isColored ? 'red' : '')"
          title="DPB1*"
          width="75"
        ></grid-column>
        <grid-column
          :name="filterQuery.patientId ? 'hlaDpb12' : 'dpb12'"
          :className="(row) => (query.patientId && row.isColored ? 'red' : '')"
          title="  "
          width="50"
        ></grid-column>
        <grid-column name="stateNameLocalized" :title="$t('Статус')" width="60"></grid-column>
        <grid-column name="commonLocalized" :title="$t('Общая инф.')" width="100"></grid-column>
        <grid-column name="userName" :title="$t('Автор')" width="150"></grid-column>
      </rdkm-grid>
    </div>
  </layout>
</template>
<style>
.deleted-donors-data .dx-g-bs4-table-cell a {
  color: black !important;
}
.visible-donors-data tr th:nth-child(18),
.visible-donors-data tr td:nth-child(18) {
  display: none;
}
</style>
<style scoped>
.include-deleted {
  padding-top: 3px !important;
  font-size: 16px;
  line-height: 0;
}

input[type='file'] {
  display: none;
}
.custom-file-upload {
  color: #6c757d;
  border-radius: 3px;
  border: 2px solid #6c757d;
  display: inline-block;
  font-size: 12px;
  font-weight: bold;
  padding: 6px 12px;
  margin-left: 10px;
  cursor: pointer;
}
.custom-file-upload:hover {
  color: white;
  background-color: #6c757d;
}

.swal-modal {
  width: 850px !important;
}
</style>

<script>
import Vue from 'vue';
import FilterForm from './Filter.vue';
import Grid from '../../components/grid/Grid.vue';
import GridColumn from '../../components/grid/GridColumn.vue';
import axios from 'axios';
import Constants from '../../constants';
import { EventBus } from '../../event-bus';
import ExportModal from '@/pages/donors/ExportModal';
import ExportWmdaModal from '@/pages/donors/ExportWmdaModal';
import ExportFmbaModal from '@/pages/donors/ExportFmbaModal';
import ImportModal from '@/pages/donors/ImportModal';

export default {
  props: ['query'],
  components: {
    'filter-form': FilterForm,
    'rdkm-grid': Grid,
    'grid-column': GridColumn,
    'export-modal': ExportModal,
    'export-wmda-modal': ExportWmdaModal,
    'export-fmba-modal': ExportFmbaModal,
    'import-modal': ImportModal,
  },
  data() {
    return {
      file: '',
      patient: null,
      showDeleted: false,
      filterQuery: {},
    };
  },
  beforeMount() {
    this.filterQuery = Object.assign({}, this.query);
    if (this.$auth.user().isLr) {
      this.filterQuery.lrOrganizationId = this.$auth.user().currentOrganization.id;
    }
    this.showDeleted = this.filterQuery.showDeleted == 'true' || false;
  },
  methods: {
    changeDeletedFilter(e) {
      this.showDeleted = e;
    }
  },
  created() {
    EventBus.$emit('showThrobber');
    const self = this;
    if (this.query.patientId) {
      axios.get('/patients/' + this.query.patientId).then((response) => {
        self.patient = response.data;
        EventBus.$emit('hideThrobber');
      });
    } else {
      EventBus.$emit('hideThrobber');
    }
  },
  computed: {
    exportUrl() {
      return (
        Constants.baseUrl +
        '/donors/ExportSearchResults?patientId=' +
        this.query.patientId +
        '&ageFrom=' +
        this.query.ageFrom +
        '&ageTo=' +
        this.query.ageTo +
        '&coincidence=' +
        this.query.coincidence +
        '&externalId=' +
        this.query.externalId
      );
    },
    isLrCodeVisible: function() {
      return this.$auth.user().isRdkm;
    },
    isLrNameVisible: function() {
      return this.$auth.user().isRdkm && !this.query.patientId;
    },
    isOperatorVisible: function() {
      return this.$auth.user().isLr && !this.query.patientId;
    },
  },
};
</script>
